import React from 'react';
import Hero from '../../components/public/Hero';

const SystemFlow = () => {
    const processSteps = [
        {
            title: 'Reality Diagnosis',
            description: 'We assess your current economic position honestly and completely. This includes income patterns, expense structures, obligations, assets, and liabilities. No assumptions, only facts.'
        },
        {
            title: 'Clarity Mapping',
            description: 'You understand what is working, what is not, and most importantly—why. We identify patterns, reveal blind spots, and show the complete picture of your economic reality.'
        },
        {
            title: 'Disciplined Structuring',
            description: 'We design systems tailored to your situation that reduce instability and improve control. These aren\'t generic templates but frameworks built specifically for your circumstances.'
        }
    ];

    const benefits = [
        {

            title: 'Proven Methodology',
            description: 'Our systematic approach has helped hundreds achieve their goals'
        },
        {

            title: 'Expert Guidance',
            description: 'Learn from experienced professionals dedicated to your success'
        },
        {

            title: 'Continuous Support',
            description: 'Ongoing assistance and resources throughout your journey'
        },
        {

            title: 'Digital Tools',
            description: 'Access modern tools and platforms for seamless collaboration'
        }
    ];

    return (
        <div className="system-flow-page">
            <Hero
                title="How the Yathartha System Works"
                subtitle="Our Process"
                description="A proven, step-by-step methodology designed to guide you from clarity to success"
                backgroundImage="/Financial.png"
            />

            {/* Intro Section */}
            <section className="flow-intro-section">
                <div className="container">
                    <div className="flow-intro-text">
                        <p>
                            Our framework follows a structured, progressive approach. Each stage builds understanding and creates foundations for the next. This is not a quick process—it is a thorough one.
                        </p>
                    </div>
                </div>
            </section>

            {/* Process Steps */}
            <section className="process-steps-section">
                <div className="container">
                    <div className="process-steps-grid">
                        {processSteps.map((step, index) => (
                            <div
                                key={index}
                                className="process-step-box"
                                style={{ animationDelay: `${index * 0.15}s` }}
                            >
                                <h3>{step.title}</h3>
                                <p>{step.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Stability Message */}
            <section className="stability-message-section">
                <div className="container">
                    <div className="stability-message-box">
                        <h3>Stability Over Time</h3>
                        <p>
                            Progress is measured, realistic and sustainable. We track improvements, adjust systems as needed, and ensure stability becomes your new normal—not a temporary achievement.
                        </p>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="benefits-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">Why Choose Our System</h2>
                        <p className="section-description">
                            Experience the advantages of our comprehensive approach
                        </p>
                    </div>

                    <div className="benefits-grid">
                        {benefits.map((benefit, index) => (
                            <div
                                key={index}
                                className="benefit-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="benefit-icon">{benefit.icon}</div>
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            {/* <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Begin Your Journey?</h2>
                        <p>Start with our clarity assessment and discover your path to success</p>
                        <div className="cta-buttons">
                            <a href="/begin-with-clarity" className="cta-button primary">
                                Get Started Now
                            </a>
                            <a href="/contact" className="cta-button dark">
                                Talk to an Expert
                            </a>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
    );
};

export default SystemFlow;
